import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../../index'
import { useTranslation } from 'react-i18next'

const Milk: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const breedOptions = options?.breeds?.map(breed => ({
    key: breed.key,
    value: breed.key,
    text: breed.label
  })) || []

  const totalMilkAmountUnits = options?.totalMilkAmountUnits?.map(breed => ({
    key: breed.key,
    value: breed.key,
    text: breed.label
  })) || []

  return (
    <>
      <FormFields.Select
        control={control}
        search
        name='breed'
        label={t('Main breed')}
        withoutAsterisk
        rules={{ required: true }}
        options={breedOptions}
        placeholder={t('Select main breed')}
        noErrorMessage
      />
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name='totalMilkAmount'
          withoutAsterisk
          label={t('Total milk production')}
          rules={{ required: true }}
          placeholder={t('Enter total milk amount')}
          typeInput='controled'
          noErrorMessage
      />
        <FormFields.Select
          control={control}
          name='totalMilkAmountUnit'
          placeholder={t('Enter unit')}
          withoutAsterisk
          rules={{ required: true }}
          options={totalMilkAmountUnits}
          label={t('Unit')}
          noErrorMessage
      />
      </Form.Group>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name='protein'
          withoutAsterisk
          label={t('Protein (%)')}
          rules={{ required: true }}
          placeholder={t('Protein (%)')}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          noErrorMessage
      />
        <FormFields.Input
          control={control}
          name='fat'
          withoutAsterisk
          label={t('Fat (%)')}
          rules={{ required: true }}
          placeholder={t('Fat (%)')}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          noErrorMessage
      />
      </Form.Group>
    </>
  )
}

export default Milk
